import React from 'react';
import classNames from 'classnames';

import { SvgIcon, SvgIconSrc } from '@components/SvgIcon';
import { fontWeightEnum, Text, textVariantsEnum } from '@components/Text';

import styles from './Checkbox.module.scss';
import { TooltipWrapper } from '../TooltipWrapper';
import { MdInfo } from 'react-icons/md';
export const CheckboxComponent = ({
  className,
  checked,
  id,
  text,
  disabled,
  onClick,
  tooltip,
}) => {
  const checkboxClass = classNames(
    styles.checkbox,
    {
      [styles.disabled]: disabled,
      [styles.checked]: checked,
    },
    className
  );
  let textToDisplay = text;
  if (typeof text === 'string') {
    textToDisplay = (
      <Text
        variant={textVariantsEnum.Text_sm}
        fontWeight={fontWeightEnum.Semibold}
        color={'gray-700'}
      >
        {text}
      </Text>
    );
  }

  return (
    <div className={checkboxClass}>
      <input
        type="checkbox"
        checked={checked}
        name={id}
        id={id}
        disabled={disabled}
        onChange={disabled ? () => null : () => onClick(id)}
      />
      <label htmlFor={id}>
        <div className={styles.checkbox_box}>
          <SvgIcon
            src={SvgIconSrc.checkbox}
            size={12}
            color={disabled ? 'gray-300' : 'white'}
          />
        </div>
        {text && textToDisplay}
      </label>
      {tooltip && (
        <TooltipWrapper tooltip={tooltip}>
          <MdInfo className={styles.infoIcon} />
        </TooltipWrapper>
      )}
    </div>
  );
};
